const currentUrl = window.location.href;
if(currentUrl.includes('/products/')){
  addStepsToFormField();
}
function addStepsToFormField(){
  document.querySelector('head').insertAdjacentHTML('beforeend', `
  <style>
  .variant-selection options-selection fieldset{
    border: 1px solid #CDCDCD !important;
    border-radius: 3px;
    padding: 28px 16px 5px !important;
    position: relative;
  }
  .variant-selection options-selection fieldset::before {
    content: "";
    width: 100%;
    height: 1px;
    background-color: #CDCDCD;
    position: absolute;
    top: -10px;
    left: 0;
  }
  legend.options-selection__option-header{
    transform: translateY(20px);
  }
  .options-selection__option-header .options-selection__option-name{
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }
  .options-selection__option-header .ca_step{
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: #8EBB3A;
  }
  legend.options-selection__option-header .ca_label{
    text-transform: uppercase;
    color: #8EBB3A;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    padding-right: 5px;
  }
  .options-selection__option-header .options-selection__option-name{
    color: #5A5A5A;
  }
  </style>
  `);
  
  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }
  
  waitForElm('.variant-selection options-selection fieldset').then((elm) => {
    setTimeout(()=>{
      const allLabels = document.querySelectorAll('options-selection legend.options-selection__option-header');
      allLabels.forEach((labelEle, i, arr) => {
        if(arr.length > 1){
          labelEle.insertAdjacentHTML('afterbegin', `<span class="ca_label">step ${i + 1}</span>`);
        }
      });
    }, 1000);
  });
}